import { useQuery } from 'react-query';

import { getTiltak } from '../../../../../services/api';
import { queryKeys } from '../../../../../utils/react-query';

export const useGetTiltak = (tiltakId: string) => {
  const { data, isLoading } = useQuery([queryKeys.measures, tiltakId], () => getTiltak(tiltakId), {
    enabled: !!tiltakId
  });

  return { tiltak: data?.[0], isLoading };
};
